import { desktopTruncateStyle } from '~/styles/utilities.css';

type Props = {
  reason: string;
};

export const CreditNoteReasonCell = ({ reason }: Props) => {
  return <span className={desktopTruncateStyle}>{reason}</span>;
};
